import React from "react";
import './micro-app-loading.css';
// import ContentFooter from "./components/PageContent/ContentFooter";
function MircoAppLoading() {
  return (
    <>
      <div className="micro-app-loading" style={{minHeight:"calc(100vh - 144px)"}}>
        <div className="micro-app-logo">
          <div className="logo-container">
            <div className="logo-common-con logo-common-con-left">
              <div className="logo-common-part-con logo-part-left-con">
                <div className="logo-common-part logo-part-left"></div>
              </div>
            </div>
            <div className="logo-common-con logo-common-con-right">
              <div className="logo-common-part-con logo-part-right-con">
                <div className="logo-common-part logo-part-right"></div>
              </div>
            </div>
            <div className="logo-common-con logo-common-con-top">
              <div className="logo-common-part-con logo-part-top-con">
                <div className="logo-common-part logo-part-top"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <ContentFooter /> */}
    </>
  );
}

export default MircoAppLoading;
